<template>
  <svg width="64px" height="64px" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M5 6H19M9 10H19M5 14H19M9 18H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round"></path>
    </g>
  </svg>
</template>
<style scoped>
svg {
  transition: all 0.3s ease-in-out;
}
</style>